module.exports = __webpack_public_path__ + "img/4.b201dd50.png";